import React from 'react';
import styled from 'styled-components';

interface NoDataContainerProps {
  /** 노데이터 메시지 */
  message: string;
  /** 이미지 크기 (기본값: 60px) */
  imageSize?: number;
}

const NoDataContainer: React.FC<NoDataContainerProps> = ({
  message,
  imageSize = 107,
}) => {
  return (
    <Container>
      <NoDataImage 
        src="/common/nodata.svg" 
        alt="No data" 
        width={imageSize}
        height={imageSize}
      />
      <NoDataText>{message}</NoDataText>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: 380px;
  gap: 20px;
`;

const NoDataImage = styled.img`
  opacity: 0.5;
`;

const NoDataText = styled.span`
  color: #949494;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
`;

export default NoDataContainer;
